export default {"src":"/_next/static/media/fact_dish.37afa801.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};